// mutations
const INVENTORY_PRODUCTS_ALL = (state, inventoryProducts) => {
  if (inventoryProducts.code === 1) {
    state.inventoryProducts = inventoryProducts.data
    state.status = 'success'
  } else {
    alert(inventoryProducts.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_FORM = (state, inventoryProducts) => {
  if (inventoryProducts.code === 1) {
    state.inventoryProducts = inventoryProducts.data
    state.status = 'success'
  } else {
    alert(inventoryProducts.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_SHOW = (state, inventoryProducts) => {
  if (inventoryProducts.code === 1) {
    state.inventoryProducts = inventoryProducts.data
    state.status = 'success'
  } else {
    alert(inventoryProducts.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_CREATE = (state, inventoryProducts) => {
  if (inventoryProducts.code === 1) {
    state.inventoryProducts = inventoryProducts.data
    state.status = 'success'
    alert(inventoryProducts.message)
  } else {
    alert(inventoryProducts.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_UPDATE = (state, inventoryProducts) => {
  if (inventoryProducts.code === 1) {
    state.inventoryProducts = inventoryProducts.data
    state.status = 'success'
    alert(inventoryProducts.message)
  } else {
    alert(inventoryProducts.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_DELETE = (state, inventoryProducts) => {
  if (inventoryProducts.code === 1) {
    state.inventoryProducts = inventoryProducts.data
    state.status = 'success'
    alert(inventoryProducts.message)
  } else {
    alert(inventoryProducts.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_ADD = (state, inventoryProducts) => {
  if (inventoryProducts.code === 1) {
    state.inventoryProducts = inventoryProducts.data
    state.status = 'success'
    alert(inventoryProducts.message)
  } else {
    alert(inventoryProducts.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_MINUS = (state, inventoryProducts) => {
  if (inventoryProducts.code === 1) {
    state.inventoryProducts = inventoryProducts.data
    state.status = 'success'
    alert(inventoryProducts.message)
  } else {
    alert(inventoryProducts.message)
    state.status = 'error'
  }
}

export default {
  INVENTORY_PRODUCTS_ALL,
  INVENTORY_PRODUCTS_FORM,
  INVENTORY_PRODUCTS_SHOW,
  INVENTORY_PRODUCTS_CREATE,
  INVENTORY_PRODUCTS_UPDATE,
  INVENTORY_PRODUCTS_DELETE,
  INVENTORY_PRODUCTS_ADD,
  INVENTORY_PRODUCTS_MINUS
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/products/mutations.js